export default () => ({
  isAuthenticated: false,
  token: null,
  user: {
    name: "",
    role: null,
  },
});
